import { RoleGroup, RoleType } from '../../models/Role'
import { env } from '../../common/util'

interface EnvRoleMapping {
  prod: string
  staging: string
  dev: string
}

export enum RoleGroupKind {
  INVITABLE,
  CROSS_ACCOUNT_GRANTABLE,
}

interface RoleGroupWithKind extends RoleGroup {
  kinds: RoleGroupKind[]
}

export const ownerRoles: EnvRoleMapping = { prod: 'c7jximvkjagbh0n8', staging: '9zip1cx4oi5lt3ii', dev: '5raikjdb92ws5ju6' }
export const adminRoles: EnvRoleMapping = { prod: '1cuebwhxuxhzdvvi', staging: '2fj5t1nz70wd4f4l', dev: 'dh90p1kwu2s84wes' }
export const enterpriseAdminRoles: EnvRoleMapping = { prod: 'hodbdwvxxtpzjff4', staging: 'mknezlto36cms69t', dev: 'jrwef3zugrfarzsf' }
export const professionalRoles: EnvRoleMapping = { prod: '98rhc42q33x2vqjl', staging: '1304esp8q7uxgc9n', dev: '10cyp13r3pvudt93' }
export const sidecarRoles: EnvRoleMapping = { prod: 'nb5aphuvqngljca3', staging: 'dsqeuufsbuxejirp', dev: 'fsjjasjrvihxtpuk' }
export const templateAdminRoles: EnvRoleMapping = { prod: 'chpnkcxeljl6cu2d', staging: '2bo3smest8vgw5z3', dev: '33m56jk846xgfe1r' }

export const roleGroups: RoleGroupWithKind[] = [
  {
    name: 'User',
    roleIds: [professionalRoles[env]],
    type: RoleType.SEAT,
    kinds: [RoleGroupKind.INVITABLE],
  },
  {
    name: 'Template Manager User',
    roleIds: [professionalRoles[env], templateAdminRoles[env]],
    type: RoleType.SEAT,
    kinds: [RoleGroupKind.INVITABLE],
  },
  {
    name: 'Administrative Assistant',
    roleIds: [sidecarRoles[env]],
    type: RoleType.SIDECAR,
    kinds: [RoleGroupKind.INVITABLE, RoleGroupKind.CROSS_ACCOUNT_GRANTABLE],
  },
  {
    name: 'Administrative Assistant with Templates',
    roleIds: [sidecarRoles[env], templateAdminRoles[env]],
    type: RoleType.SIDECAR,
    kinds: [RoleGroupKind.INVITABLE, RoleGroupKind.CROSS_ACCOUNT_GRANTABLE],
  },
  {
    name: 'Administrator',
    roleIds: [adminRoles[env], professionalRoles[env]],
    type: RoleType.SEAT,
    kinds: [RoleGroupKind.INVITABLE],
  },
  {
    name: 'Owner',
    roleIds: [ownerRoles[env], professionalRoles[env]],
    type: RoleType.SEAT,
    kinds: [RoleGroupKind.INVITABLE],
  },
  {
    name: 'Owner, Enterprise Administrator',
    roleIds: [ownerRoles[env], enterpriseAdminRoles[env], professionalRoles[env]],
    type: RoleType.SEAT,
    kinds: [],
  },
  {
    name: 'Administrator, Enterprise Administrator',
    roleIds: [adminRoles[env], enterpriseAdminRoles[env], professionalRoles[env]],
    type: RoleType.SEAT,
    kinds: [],
  },
]

export const getInviteRoleGroups = ({
  onlyInvitable = false,
  onlyCrossAccountGrantable = false,
}: { onlyInvitable?: boolean; onlyCrossAccountGrantable?: boolean } = {}) => {
  return roleGroups.filter(
    (rg) =>
      (!onlyInvitable || rg.kinds.includes(RoleGroupKind.INVITABLE)) &&
      (!onlyCrossAccountGrantable || rg.kinds.includes(RoleGroupKind.CROSS_ACCOUNT_GRANTABLE)),
  ) as RoleGroup[]
}

export const getRoleGroupForRoles = (roleIds: string[]): RoleGroup | null => {
  const inviteRole = getInviteRoleGroups().find(
    (roleGroup) => roleGroup.roleIds.length === roleIds.length && [...roleGroup.roleIds].sort().every((val, index) => val === [...roleIds].sort()[index]),
  )
  return inviteRole || null
}
